export const RISK_LEVEL_POINT = {
    LEVEL_4: 2000,
    LEVEL_3: 1000,
    LEVEL_2: 600,
    LEVEL_1: 300,
}

export const BSN_RISK_LEVEL_POINT = {
    LEVEL_4: 15,
    LEVEL_3: 8,
    LEVEL_2: 5,
    LEVEL_1: 2,
}

// 風の閾値を設定
export const WIND_LEVEL_POINT = {
    LEVEL_5: 25,
    LEVEL_4: 20,
    LEVEL_3: 15,
    LEVEL_2: 10,
    LEVEL_1: 5,
}

export const RISK_COLOR = {
    LEVEL_5: { label: '危険', color: "rgb(185, 46, 201)", font_color: "#fff" },   // #b840f2
    LEVEL_4: { label: '厳重警戒', color: "rgb(255, 38, 0)", font_color: "#fff" },   // #f2404c
    LEVEL_3: { label: '警戒', color: "rgb(242, 139, 65)", font_color: "#fff" },   // #f28b41
    LEVEL_2: { label: '注意', color: "rgb(250, 246, 0)", font_color: "rgb(93, 93, 93)" },    // #f2ec40
    LEVEL_1: { label: '通常', color: "rgb(0, 146, 209)", font_color: "#fff" },   // #4093f2
    OTHER: { label: '-', color: "rgb(77, 77, 78)", font_color: "#fff" }
};

export const BSN_RISK_COLOR = {
    LEVEL_5: { label: '危険', color: "#b92ec9", font_color: "#fff" },
    LEVEL_4: { label: '厳重警戒', color: "#ff2600", font_color: "#fff" },
    LEVEL_3: { label: '警戒', color: "#f28b41", font_color: "#fff" },
    LEVEL_2: { label: '注意', color: "#faf600", font_color: "rgb(93, 93, 93)" },
    LEVEL_1: { label: '通常', color: "#0092d1", font_color: "#fff" },
    OTHER: { label: '-', color: "rgb(77, 77, 78)", font_color: "#fff" }
};

export const AREA_RISK_COLOR = {
    LEVEL_5: { label: 'レベル4', color: "#b92ec9", font_color: "#fff", font_size: "1.6rem" },
    LEVEL_4: { label: 'レベル3', color: "#ff2600", font_color: "#fff", font_size: "1.6rem" },
    LEVEL_3: { label: 'レベル2', color: "#f28b41", font_color: "#fff", font_size: "1.6rem" },
    LEVEL_2: { label: 'レベル1', color: "#faf600", font_color: "rgb(93, 93, 93)", font_size: "1.6rem" },
    LEVEL_1: { label: 'レベル0', color: "#0092d1", font_color: "#fff", font_size: "1.6rem" },
    OTHER: { label: '-', color: "rgb(77, 77, 78)", font_color: "#fff", font_size: "1.6rem" }
}


export const RAIN_COLOR = {
    LEVEL_1: { color: "rgb(242, 242, 255)", font_color: "rgb(93, 93, 93)", ranklabel_font_color: "#999999" },   // 0 → ごく弱い雨
    LEVEL_2: { color: "rgb(160, 210, 255)", font_color: "rgb(93, 93, 93)", ranklabel_font_color: "#999999" },   // 1
    LEVEL_3: { color: "rgb(33, 140, 255)", font_color: "#fff", ranklabel_font_color: "#fff" },    // 2
    LEVEL_4: { color: "rgb(0, 65, 255)", font_color: "#fff", ranklabel_font_color: "#fff" },      // 3
    LEVEL_5: { color: "rgb(250, 245, 0)", font_color: "rgb(93, 93, 93)", ranklabel_font_color: "#999999" },     // 4 → 強雨の開始
    LEVEL_6: { color: "rgb(255, 153, 0)", font_color: "#fff", ranklabel_font_color: "#fff" },     // 5
    LEVEL_7: { color: "rgb(255, 40, 0)", font_color: "#fff", ranklabel_font_color: "#fff" },      // 6
    LEVEL_8: { color: "rgb(180, 0, 104)", font_color: "#fff", ranklabel_font_color: "#fff" },     // 7 → 極端な雨量
    OTHER: { color: "rgb(77, 77, 78)", font_color: "#fff", ranklabel_font_color: "#fff" }      // データなし・対象外など
};

export const SR_RISK_COLOR = {
    LEVEL_1: { label: '平常', color: "rgb(0, 146, 209)", font_color: "#fff", font_size: "1.6rem" },    // #0092d1：水色
    LEVEL_2: { label: '注意報相当', color: "rgb(250, 246, 0)", font_color: "rgb(93, 93, 93)", font_size: "1.6rem" },     // #faf600：黄
    LEVEL_3: { label: '警報相当', color: "rgb(255, 38, 0)", font_color: "#fff", font_size: "1.6rem" },    // #ff2600：赤
    LEVEL_4: { label: '危険警報相当', color: "rgb(185, 46, 201)", font_color: "#fff", font_size: "1.6rem" },    // #b92ec9：紫
    LEVEL_5: { label: '特別警報相当', color: "rgb(83, 79, 89)", font_color: "#fff", font_size: "1.6rem" },   // #534f59：黒（グレー系）
    OTHER: { label: '-', color: "rgb(128, 128, 128)", font_color: "#fff", font_size: "1.6rem" }   // #aaaaaa：その他・グレー
};


export const SOIL_RISK_COLOR = {
    LEVEL_1: { label: '平常', color: "#0092d1", font_color: "#fff", size_point: 10, font_size: "1.6rem" },
    LEVEL_2: { label: '注意報相当（最低）', color: "#faf600", font_color: "rgb(93, 93, 93)", size_point: 10, font_size: "1.2rem" },
    LEVEL_3: { label: '警報相当', color: "#ff2600", font_color: "#fff", size_point: 10, font_size: "1.6rem" },
    LEVEL_4: { label: '危険警報相当（最低）', color: "#b92ec9", font_color: "#fff", size_point: 10, font_size: "1.1rem" },
    LEVEL_5: { label: '特別警報相当（最低）', color: "#534f59", font_color: "#fff", size_point: 10, font_size: "1.1rem" },
};

export const SOIL_RAIN_COLOR = {
    LEVEL_1: { label: '平常', color: "#0092d1", font_color: "#fff", size_point: 10, font_size: "1.6rem" },
    LEVEL_2: { label: '注意報相当', color: "#faf600", font_color: "rgb(93, 93, 93)", size_point: 10, font_size: "1.2rem" },
    LEVEL_3: { label: '警報相当', color: "#ff2600", font_color: "#fff", size_point: 10, font_size: "1.6rem" },
    LEVEL_4: { label: '危険警報相当', color: "#b92ec9", font_color: "#fff", size_point: 10, font_size: "1.1rem" },
    LEVEL_5: { label: '特別警報相当', color: "#534f59", font_color: "#fff", size_point: 10, font_size: "1.1rem" },
};

export const RAIN_H1_LEVEL_POINT = {
    LEVEL_7: 80,
    LEVEL_6: 50,
    LEVEL_5: 30,
    LEVEL_4: 20,
    LEVEL_3: 10,
    LEVEL_2: 5,
    LEVEL_1: 1,
}
export const RAIN_H24_LEVEL_POINT = {
    LEVEL_7: 300,
    LEVEL_6: 250,
    LEVEL_5: 200,
    LEVEL_4: 150,
    LEVEL_3: 100,
    LEVEL_2: 80,
    LEVEL_1: 50,
}
export const RAIN_H48_LEVEL_POINT = {
    LEVEL_7: 400,
    LEVEL_6: 300,
    LEVEL_5: 250,
    LEVEL_4: 200,
    LEVEL_3: 150,
    LEVEL_2: 100,
    LEVEL_1: 50,
}
export const RAIN_FLOOD_H1_LEVEL_POINT = {
    LEVEL_6: 100,
    LEVEL_5: 70,
    LEVEL_4: 50,
    LEVEL_3: 30,
    LEVEL_2: 20,
    LEVEL_1: 10,
}
export const RAIN_FLOOD_H24_H48_LEVEL_POINT = {
    LEVEL_7: 500,
    LEVEL_6: 400,
    LEVEL_5: 300,
    LEVEL_4: 200,
    LEVEL_3: 150,
    LEVEL_2: 100,
    LEVEL_1: 50,
}

export const SR_RISK_LEVEL_POINT = {
    LEVEL_2: 2,
    LEVEL_3: 3,
    LEVEL_4: 4,
    LEVEL_5: 5,
}

export const TEL_LEVEL_POINT = {
    PURPLE: 6,
    RED: 5,
    YELLOW: 4,
    GREEN: 3,
    BLUE: 2,
}

export const TYPHOON_LEVEL_POINT = {
    LEVEL_4: 100,
    LEVEL_3: 70,
    LEVEL_2: 30,
    LEVEL_1: 1,
}

export const TEL_LEVEL_STR = {
    PURPLE: "氾濫危険水位",
    RED: "避難判断水位",
    YELLOW: "氾濫注意水位",
    GREEN: "水防団待機水位",
    BLUE: "平常",
    OTHER: "欠測",
}

export const RIVER_COLOR = {
    LEVEL_5: "#9d49c5",
    LEVEL_4: "#fd5367",
    LEVEL_3: "#fec242",
    LEVEL_2: "#faf500",
    LEVEL_1: "#79b9ed",
    OTHER: "#808080",
}
export const MTR_BORDER_COLOR = {
    PURPLE: "#b92ec9", // 紫
    RED: "#ff2600", // 赤
    YELLOW: "#faf600", // 黄
    GREEN: "#71c766", // 緑
    BLUE: "#0092d1", // 水色
    OTHER: "#3d3d3d",
}
export const SENIOR_RISK_LEVEL_POINT = {
    LEVEL_5: 200000,
    LEVEL_4: 100000,
    LEVEL_3: 60000,
    LEVEL_2: 30000,
}
export const SENIOR_RISK_COLOR = {
    LEVEL_5: "#8c60c9",
    LEVEL_4: "#db577b",
    LEVEL_3: "#4fa77c",
    LEVEL_2: "#d97a49",
    LEVEL_1: "#6797d5",
    OTHER: "#808080",
}
export const ISORATION_RISK_LEVEL_POINT = {
    LEVEL_5: 9999,
    LEVEL_4: 2000,
    LEVEL_3: 1000,
    LEVEL_2: 600,
    LEVEL_1: 300,
}

export const ISORATION_RISK_COLOR = {
    LEVEL_6: "#00aabd",
    LEVEL_5: "#8c60c9",
    LEVEL_4: "#db577b",
    LEVEL_3: "#4fa77c",
    LEVEL_2: "#d97a49",
    LEVEL_1: "#6797d5",
    OTHER: "#808080",
}
export const CHRONOLOGY_CATEGORY_CODE = {
    COLLAPSE: 1,
    WATERLV: 2,
    CAVE_IN: 3,
    ROAD: 4,
    FLOOD: 5,
    WATER_CHANNEL: 6,
    POWER_OUTAGE: 7,
    WATER_OUTAGE: 8,
    GAS: 9,
    COMMUNICATION: 10,
    WIND_LIGNTNING: 11,
    FIRE: 12,
    TSUNAMI: 13,
    OTHER: 99,
}

export const CHRONOLOGY_CATEGORY_NAME = {
    COLLAPSE: '崩土',
    WATERLV: '浸水・冠水',
    CAVE_IN: '陥没',
    ROAD: '路層崩壊',
    FLOOD: '氾濫',
    WATER_CHANNEL: '河道閉塞',
    POWER_OUTAGE: '停電',
    WATER_OUTAGE: '断水',
    GAS: 'ガス停止',
    COMMUNICATION: '通信障害',
    WIND_LIGNTNING: '突風・落雷',
    FIRE: '火災',
    TSUNAMI: '津波',
    OTHER: 'その他',
}

export const CHRONOLOGY_CATEGORY_COLOR = {
    COLLAPSE: '#5899da',
    WATERLV: '#e8743b',
    CAVE_IN: '#19a979',
    ROAD: '#ed4a7b',
    FLOOD: '#945ecf',
    WATER_CHANNEL: '#13a4b4',
    POWER_OUTAGE: '#525df4',
    WATER_OUTAGE: '#bf399e',
    GAS: '#6c8893',
    COMMUNICATION: '#ee6868',
    WIND_LIGNTNING: '#2f6497',
    FIRE: '#1866b4',
    TSUNAMI: '#cc4300',
    OTHER: "#808080",
}

// export const CHRONOLOGY_LEVEL = {
//     HIGHT: 3,
//     MIDDLE: 2,
//     LOW: 1,
//     OTHER: 99,
// }

// export const CHRONOLOGY_LEVEL_COLOR = {
//     HIGHT: '#F7766F',
//     MIDDLE: '#FFE066',
//     LOW: '#87E876',
//     OTHER: "#E5E5E5",
// }

export const CHRONOLOGY_LEVEL_LABEL = {
    LEVER_1: "崩壊・損傷",
    LEVER_2: "土砂崩れ",
    LEVER_3: "冠水・浸水",
    LEVER_4: "倒木",
    LEVER_5: "停電・断線",
    LEVER_6: "断水・破断",
    LEVER_7: "交通規制",
    LEVER_8: "決壊",
    LEVER_9: "その他被害", 
}

export const CHRONOLOGY_LEVEL_COLOR = {
    LEVER_1: "#b07aa1",
    LEVER_2: "#e15759",
    LEVER_3: "#76b7b2",
    LEVER_4: "#59a14f",
    LEVER_5: "#f28e2b",
    LEVER_6: "#76b7b2",
    LEVER_7: "#edc948",
    LEVER_8: "#454ed1",
    LEVER_9: "#bab0ac",
    OTHER: "#E5E5E5",
}

export const HAZERD_FLOOD_LEVEL_POINT = {
    LEVEL_6: 6,
    LEVEL_5: 5,
    LEVEL_4: 4,
    LEVEL_3: 3,
    LEVEL_2: 2,
    LEVEL_1: 1,
}
export const HAZERD_FLOOD_LEVEL_TEXT = {
    LEVEL_6: '20.0m 〜 ',
    LEVEL_5: '10.0m 〜 20.0m',
    LEVEL_4: '5.0m 〜 10.0m',
    LEVEL_3: '3.0m 〜 5.0m',
    LEVEL_2: '0.5m 〜 3.0m',
    LEVEL_1: '〜 0.5m',
}
export const HAZERD_FLOOD_LEVEL_COLOR = {
    LEVEL_6: 'rgb(220,122,220)',
    LEVEL_5: 'rgb(242,133,201)',
    LEVEL_4: 'rgb(255,145,145)',
    LEVEL_3: 'rgb(255,183,183)',
    LEVEL_2: 'rgb(255,216,192)',
    LEVEL_1: 'rgb(247,245,169)',
    OTHER: 'rgb(0, 0, 0, 0)',
}

export const HAZERD_INLAND_FLOOD_LEVEL_POINT = {
    LEVEL_4: 4,
    LEVEL_3: 3,
    LEVEL_2: 2,
    LEVEL_1: 1,
}
export const HAZERD_INLAND_FLOOD_LEVEL_COLOR = {
    LEVEL_4: 'rgb(8,109,254)',
    LEVEL_3: 'rgb(153,255,153)',
    LEVEL_2: 'rgb(255,255,102)',
    LEVEL_1: 'rgb(255,203,255)',
    OTHER: 'rgb(0, 0, 0, 0)',
}
export const HAZERD_LANDSLIDE_LEVEL_POINT = {
    LEVEL_2: 2,
    LEVEL_1: 1,
}
export const HAZERD_LANDSLIDE_LEVEL_COLOR = {
    LEVEL_2: 'rgb(193,9,9)',
    LEVEL_1: 'rgb(237,231,56)',
    OTHER: 'rgb(0, 0, 0, 0)',
}
export const TEL_RISK_LEVEL_POINT = {
    LEVEL_6: 6,
    LEVEL_5: 5,
    LEVEL_4: 4,
    LEVEL_3: 3,
    LEVEL_2: 2,
    LEVEL_1: 1
}
export const TEL_RISK_COLOR = {
    LEVEL_6: '#b92ec9',
    LEVEL_5: '#ff2600',
    LEVEL_4: '#faf600',
    LEVEL_3: '#71c766',
    LEVEL_2: '#0092d1',
    LEVEL_1: '#3d3d3d'
}
export const ROAD_LEVEL_POINT = {
    LEVEL_4: 4,
    LEVEL_3: 3,
    LEVEL_2: 2,
    LEVEL_1: 1,
    LEVEL_0: 0
}
export const ROAD_COLOR = {
    LEVEL_4: '#b92ec9',
    LEVEL_3: '#ff2600',
    LEVEL_2: '#f28b41',
    LEVEL_1: '#faf600',
    LEVEL_0: '#0092d1'
}
export const RAIN_H1_RISK_LEVEL_POINT = {
    LEVEL_4: 80,
    LEVEL_3: 50,
    LEVEL_2: 30,
    LEVEL_1: 20,
}
// export const RAIN_H1_COLOR = {
//     LEVEL_5: { label: '猛烈な雨', color: "rgb(157, 73, 197)", font_color: "#fff" },   // #9d49c5
//     LEVEL_4: { label: '非常に激しい雨', color: "rgb(253, 83, 103)", font_color: "#fff" },   // #fd5367
//     LEVEL_3: { label: '激しい雨', color: "rgb(250, 245, 0)", font_color: "rgb(93, 93, 93)" },   // #faf500
//     LEVEL_2: { label: '強い雨', color: "rgb(113, 199, 102)", font_color: "#fff" },    // #71c766
//     LEVEL_1: { label: '基準未満', color: "rgb(99, 187, 242)", font_color: "#fff" },   // #63bbf2
//     OTHER: { label: '-', color: "rgb(77, 77, 78)", font_color: "#fff" },
// };
export const RAIN_H1_COLOR = {
    LEVEL_8: { label: `${RAIN_H1_LEVEL_POINT.LEVEL_7} 〜`, color: RAIN_COLOR.LEVEL_8.color, font_color: RAIN_COLOR.LEVEL_8.font_color },
    LEVEL_7: { label: `${RAIN_H1_LEVEL_POINT.LEVEL_6} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_7}`, color: RAIN_COLOR.LEVEL_7.color, font_color: RAIN_COLOR.LEVEL_7.font_color },
    LEVEL_6: { label: `${RAIN_H1_LEVEL_POINT.LEVEL_5} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_6}`, color: RAIN_COLOR.LEVEL_6.color, font_color: RAIN_COLOR.LEVEL_6.font_color },
    LEVEL_5: { label: `${RAIN_H1_LEVEL_POINT.LEVEL_4} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_5}`, color: RAIN_COLOR.LEVEL_5.color, font_color: RAIN_COLOR.LEVEL_5.font_color },
    LEVEL_4: { label: `${RAIN_H1_LEVEL_POINT.LEVEL_3} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_4}`, color: RAIN_COLOR.LEVEL_4.color, font_color: RAIN_COLOR.LEVEL_4.font_color },
    LEVEL_3: { label: `${RAIN_H1_LEVEL_POINT.LEVEL_2} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_3}`, color: RAIN_COLOR.LEVEL_3.color, font_color: RAIN_COLOR.LEVEL_3.font_color },
    LEVEL_2: { label: `${RAIN_H1_LEVEL_POINT.LEVEL_1} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_2}`, color: RAIN_COLOR.LEVEL_2.color, font_color: RAIN_COLOR.LEVEL_2.font_color },
    LEVEL_1: { label: ` 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_1}`, color: RAIN_COLOR.LEVEL_1.color, font_color: RAIN_COLOR.LEVEL_1.font_color },
    OTHER: { label: '-', color: "rgb(77, 77, 78)", font_color: "#fff" },
};
  
// 台風の色分けを設定
export const TYPHOON_COLOR = {
    LEVEL_4: { label: `${TYPHOON_LEVEL_POINT.LEVEL_3} % 〜 ${TYPHOON_LEVEL_POINT.LEVEL_4} %`, color: "rgb(185, 46, 201)", font_color: "#fff" },   // #b92ec9
    LEVEL_3: { label: `${TYPHOON_LEVEL_POINT.LEVEL_2} % 〜 ${TYPHOON_LEVEL_POINT.LEVEL_3} %`, color: "rgb(237, 74, 123)", font_color: "#fff" },    // #ed4a7b
    LEVEL_2: { label: `${TYPHOON_LEVEL_POINT.LEVEL_1} % 〜 ${TYPHOON_LEVEL_POINT.LEVEL_2} %`, color: "rgb(242, 236, 65)", font_color: "rgb(93, 93, 93)" },   // #f2ec41
    LEVEL_1: { label: `0 %`, color: "rgb(92, 159, 237)", font_color: "#fff" },   // #5c9fed
    OTHER: { label: '-', color: "rgb(77, 77, 78)", font_color: "#fff" },
};

// 風の色分けを設定
export const WIND_COLOR = {
    LEVEL_6: { label: `${WIND_LEVEL_POINT.LEVEL_5} 〜`, color: "rgb(180, 0, 104)", font_color: "#fff" },
    LEVEL_5: { label: `${WIND_LEVEL_POINT.LEVEL_4} 〜 ${WIND_LEVEL_POINT.LEVEL_5}`, color: "rgb(255, 40, 0)", font_color: "#fff" },
    LEVEL_4: { label: `${WIND_LEVEL_POINT.LEVEL_3} 〜 ${WIND_LEVEL_POINT.LEVEL_4}`, color: "rgb(255, 153, 0)", font_color: "#fff" },
    LEVEL_3: { label: `${WIND_LEVEL_POINT.LEVEL_2} 〜 ${WIND_LEVEL_POINT.LEVEL_3}`, color: "rgb(250, 245, 0)", font_color: "rgb(93, 93, 93)" },   // #b92ec9
    LEVEL_2: { label: `${WIND_LEVEL_POINT.LEVEL_1} 〜 ${WIND_LEVEL_POINT.LEVEL_2}`, color: "rgb(0, 65, 255)", font_color: "#fff" },    // #ed4a7b
    LEVEL_1: { label: `0 〜 ${WIND_LEVEL_POINT.LEVEL_1}`, color: "rgb(242, 242, 255)", font_color: "rgb(93, 93, 93)" },   // #f2ec41
    OTHER: { label: '-', color: "rgb(77, 77, 78)", font_color: "#fff" },
};

export const RISK_HEATMAP_COLOR = [
    { from: 0, to: 1.99, name: '平常', color: '#0092d1' },
    { from: 2, to: 2.99, name: '注意報相当', color: '#faf600' },
    { from: 3, to: 3.99, name: '警報相当', color: '#ff2600' },
    { from: 4, to: 4.99, name: '危険警報相当', color: '#b92ec9' },
    { from: 5, to: 9.99, name: '特別警報相当', color: '#534f59' },
]

// 避難所分析の色分けを設定
export const SHELTER_ANALYSIS_LEVEL_POINT = {
    LEVEL_6: "開設している避難所",
    LEVEL_5: "過去3日間で開設した避難所",
    LEVEL_4: "閉鎖した避難所",
    LEVEL_3: "過去3日間で閉鎖した避難所",
    LEVEL_2: "急激な避難者数増減がある避難所",
    LEVEL_1: "3日以上報告がない避難所",
}
export const SHELTER_ANALYSIS_COLOR = {
    LEVEL_6: '#3391d5',
    LEVEL_5: '#98cdec',
    LEVEL_4: '#a49f9e',
    LEVEL_3: '#98cdec',
    LEVEL_2: '#d134d0',
    LEVEL_1: '#ffaa67',
}

// 避難指示発令地域の色分けを設定
export const EVAC_AREA_LEVEL_POINT = {
    LEVEL_5: 5,
    LEVEL_4: 4,
    LEVEL_3: 3,
    LEVEL_2: 2,
    LEVEL_1: 1,
    OTHER: 0
}
export const EVAC_AREA_COLOR = {
    LEVEL_5: '#0c000c',
    LEVEL_4: '#b92ec9',
    LEVEL_3: '#ff2600',
    LEVEL_2: '#faf600',
    LEVEL_1: '#ededed',
    LEVEL_0: '#bfbfbf'
}

export const EVAC_LEVEL_POINT = {
    LEVEL_5: 100,
    LEVEL_4: 99,
    LEVEL_3: 49,
    LEVEL_2: 9,
    LEVEL_1: 0
}

export const EVAC_COLOR = {
    LEVEL_1: { color: "rgb(0, 176, 80)", font_color: "#fff" },    // #00b050：緑
    LEVEL_2: { color: "rgb(153,255,153)", font_color: "#fff" },     // #99ff99：黄緑
    LEVEL_3: { color: "rgb(250, 245, 0)", font_color: "rgb(93, 93, 93)" },    // #faf500：黄
    LEVEL_4: { color: "rgb(255, 153, 0)", font_color: "#fff" },    // #ff9900：オレンジ
    LEVEL_5: { color: "rgb(253, 83, 103)", font_color: "#fff" },   // #fd5367：赤
};

export const SHELTER_ANALYSIS_BAR_LABEL = {
    COVID_19: "COVID-19",
    FLU: "インフルエンザ",
    MYCO: "マイコプラズマ肺炎",
    MYCO_CHILD: "小児マイコプラズマ肺炎",
    RS: "RSウイルス",
    CHLAMYDIA: "クラミジア肺炎",
    HERPANGINA: "ヘルパンギーナ",
    MUMPS: "ムンプス",
    ROTA: "ロタウイルス",
    PHARYNGOCONJUNCTIVAL: "咽頭結膜熱",
    APPLE: "伝染性紅斑",
    ACUTE_HEMORRHAGIC_CONJUNCTIVITIS: "急性出血性結膜炎",
    HAND_FOOT_MOUTH: "手足口病",
    ACUTE_INFECTIOUS_GASTROENTERITIS: "感染性胃腸炎",
    CHICKEN_POX: "水痘",
    EPIDEMIC_CONJUNCTIVITIS: "流行性結膜炎",
    ASEPTIC_SPINAL_CORD_MENINGITIS: "無菌性髄膜炎",
    EXANTHEM_SUBITUM: "突発性発疹",
    BACTERIAL_MENINGITIS: "細菌性髄膜炎",
    GROUP_A_HEMOLYTIC: "A群溶血性レンサ球菌咽頭炎",
}

export const SHELTER_ANALYSIS_BAR_COLOR = {
    COVID_19: "#488ccc",
    FLU: "#d87d4f",
    MYCO: "#52a37d",
    MYCO_CHILD: "#e467aa",
    RS: "#a36fc9",
    CHLAMYDIA: "#12a2af",
    HERPANGINA: "#e05c64",
    MUMPS: "#cc3da8",
    ROTA: "#636cda",
    PHARYNGOCONJUNCTIVAL: "#dc4180",
    APPLE: "#809e57",
    ACUTE_HEMORRHAGIC_CONJUNCTIVITIS: "#488ccc",
    HAND_FOOT_MOUTH: "#d87d4f",
    ACUTE_INFECTIOUS_GASTROENTERITIS: "#52a37d",
    CHICKEN_POX: "#e467aa",
    EPIDEMIC_CONJUNCTIVITIS: "#a36fc9",
    ASEPTIC_SPINAL_CORD_MENINGITIS: "#12a2af",
    EXANTHEM_SUBITUM: "#e05c64",
    BACTERIAL_MENINGITIS: "#cc3da8",
    GROUP_A_HEMOLYTIC: "#636cda",
    DEFAULT: "#E5E5E5",
}

export const SHINDO_COLOR = {
    LEVEL_1: "#ECECF5",
    LEVEL_2: "#099BF1",
    LEVEL_3: "#063AF1",
    LEVEL_4: "#FAE191",
    LEVEL_5_WEAK: "#FFE600",
    LEVEL_5_STRONG: "#F89412",
    LEVEL_6_WEAK: "#F82404",
    LEVEL_6_STRONG: "#87001B",
    LEVEL_7: "#B40068",
};

export const RIVER_RISK = [
  { max: 2, label: "欠測", color: "#3d3d3d" },
  { max: 3, label: "平常", color: "#0092d1" },
  { max: 4, label: "水防団待機水位", color: "#71c766" },
  { max: 5, label: "氾濫注意推移", color: "#faf600" },
  { max: 6, label: "避難判断推移", color: "#ff2600" },
  { max: Infinity, label: "氾濫危険水位", color: "#b92ec9" }
];

export const OF_VAL_LEVEL = [
  { min: 15, label: "危険", color: "#b92ec9" },
  { min: 8, label: "厳重警戒", color: "#ff2600" },
  { min: 5, label: "警戒", color: "#f28b41" },
  { min: 3, label: "注意", color: "#faf600" },
  { min: 0, label: "通常", color: "#0092d1" }
];

export const TANK_LEVEL_POINT = {
    LEVEL_5: 5,
    LEVEL_4: 4,
    LEVEL_3: 3,
    LEVEL_2: 2,
    LEVEL_1: 1,
}

export const ROAD_RISK_LEVEL_POINT = {
    LEVEL_4: 2000,
    LEVEL_3: 1000,
    LEVEL_2: 600,
    LEVEL_1: 300
}

export const ROAD_RISK_COLOR = {
    LEVEL_4: '#b92ec9',
    LEVEL_3: '#ff2600',
    LEVEL_2: '#f28b41',
    LEVEL_1: '#faf600',
    LEVEL_0: '#0092d1'
}